export function isBinance() {
    const email = sessionStorage.getItem('emailUser')?.toString();
    const criptoEmails = [
      'nathan.diogo@cipay.com.br',
      'financeiro@higherglobal.com.br',
      'account.test@higherglobal.com.br',
    ];
  
    return criptoEmails.includes(email);
}